var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/overflow_menu.f8d3caba.png","uri@2x": __webpack_public_path__ + "static/media/overflow_menu.5c0af575.png","uri@3x": __webpack_public_path__ + "static/media/overflow_menu.07a194e4.png",
    width: 32,
    height: 32
});